import { render } from "./panel_register.html?vue&type=template&id=279236e0&external"
import script from "./panel_register.js?vue&type=script&lang=js&external"
export * from "./panel_register.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__